"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WithContainer = exports.GALLERY_MAX_THUMBNAIL_COUNT = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _react = _interopRequireWildcard(require("react"));
var _usePrevious = require("b2b-components/hooks/usePrevious");
var _Gallery = require("../Gallery");
var _useRemoveMagicZoomFromDOM = require("../hooks/useRemoveMagicZoomFromDOM");
var _ = require("../");
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj["default"] = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
var GALLERY_MAX_THUMBNAIL_COUNT = 9;
exports.GALLERY_MAX_THUMBNAIL_COUNT = GALLERY_MAX_THUMBNAIL_COUNT;
var WithContainer = function WithContainer(props) {
  (0, _useRemoveMagicZoomFromDOM.useRemoveMagicZoomFromDOM)();
  var image360 = props.image360,
    images = props.images,
    videos = props.videos;
  var totalImageCount = (images === null || images === void 0 ? void 0 : images.length) || 0;
  var totalImage360Count = image360 ? 1 : 0;
  var totalVideoCount = (videos === null || videos === void 0 ? void 0 : videos.length) || 0;
  var totalItemCount = totalImageCount + totalImage360Count + totalVideoCount;
  var itemIndexArray = Array.from(Array(totalItemCount).keys());
  var itemTypeArray = (0, _react.useMemo)(function () {
    return [].concat((0, _toConsumableArray2["default"])(Array(totalImageCount).fill(_.GALLERY_ITEM_TYPE.image)), (0, _toConsumableArray2["default"])(Array(totalImage360Count).fill(_.GALLERY_ITEM_TYPE.image360)), (0, _toConsumableArray2["default"])(Array(totalVideoCount).fill(_.GALLERY_ITEM_TYPE.video)));
  }, [totalImage360Count, totalImageCount, totalVideoCount]);
  var _useState = (0, _react.useState)(0),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    currentItemIndex = _useState2[0],
    setCurrentItemIndex = _useState2[1];
  var _useState3 = (0, _react.useState)(itemTypeArray[0]),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    currentItemType = _useState4[0],
    setCurrentItemType = _useState4[1];
  var _useState5 = (0, _react.useState)(0),
    _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
    currentPreviewItemIndex = _useState6[0],
    setCurrentPreviewItemIndex = _useState6[1];
  var _useState7 = (0, _react.useState)(false),
    _useState8 = (0, _slicedToArray2["default"])(_useState7, 2),
    isModalOpened = _useState8[0],
    setIsModalOpened = _useState8[1];
  var prevItemIndex = (0, _usePrevious.usePrevious)(currentItemIndex);
  var handleItemChange = (0, _react.useCallback)(function (itemIndex) {
    if (typeof itemIndex === 'number' || typeof itemIndex === 'string') {
      setCurrentItemIndex(itemIndex);
      setCurrentItemType(itemTypeArray[itemIndex]);
    }
  }, [itemTypeArray]);
  var handlePreviewItemChange = (0, _react.useCallback)(function (itemIndex) {
    setCurrentItemIndex(itemIndex);
    setCurrentItemType(itemTypeArray[itemIndex]);
    setCurrentPreviewItemIndex(itemIndex);
  }, [itemTypeArray]);
  var handlePreviewItemClick = (0, _react.useCallback)(function (e) {
    e.preventDefault();
    setCurrentItemIndex(currentPreviewItemIndex);
    setCurrentItemType(itemTypeArray[currentPreviewItemIndex]);
    setIsModalOpened(true);
  }, [currentPreviewItemIndex, itemTypeArray]);
  var handleMobileMenuItemClick = (0, _react.useCallback)(function (itemType) {
    return function (e) {
      var _window$MagicZoom;
      e.preventDefault();
      //fix for magic toolbox in mobiles - after change section on mobiles, zoom didn't disappear
      (_window$MagicZoom = window.MagicZoom) === null || _window$MagicZoom === void 0 ? void 0 : _window$MagicZoom.refresh();
      setCurrentItemIndex(itemTypeArray.indexOf(itemType));
      setCurrentItemType(itemType);
    };
  }, [itemTypeArray]);
  var handleModalClose = (0, _react.useCallback)(function () {
    var _window;
    setIsModalOpened(false);

    // fix for magic toolbox in mobiles - after close of lightbox zoom didn't disappear
    if ((_window = window) !== null && _window !== void 0 && _window.mzIsZoomed) {
      var _window$MagicZoom2;
      (_window$MagicZoom2 = window.MagicZoom) === null || _window$MagicZoom2 === void 0 ? void 0 : _window$MagicZoom2.refresh();
      window.mzIsZoomed = false;
    }
  }, [setIsModalOpened]);
  var handleModalKeyDown = (0, _react.useCallback)(function (key) {
    if (key === 'ArrowLeft' || key === 'Left') {
      var index = currentItemIndex - 1 < 0 ? itemIndexArray.length - 1 : currentItemIndex - 1;
      setCurrentItemIndex(index);
      setCurrentItemType(itemTypeArray[index]);
    }
    if (key === 'ArrowRight' || key === 'Right') {
      var _index = currentItemIndex + 1 >= itemIndexArray.length ? 0 : currentItemIndex + 1;
      setCurrentItemIndex(_index);
      setCurrentItemType(itemTypeArray[_index]);
    }
  }, [itemIndexArray, itemTypeArray, currentItemIndex]);
  var injectedProps = {
    currentItemIndex: currentItemIndex,
    currentItemType: currentItemType,
    currentPreviewItemIndex: currentPreviewItemIndex,
    itemIndexArray: itemIndexArray,
    isModalOpened: isModalOpened,
    onItemChange: handleItemChange,
    onMobileMenuItemClick: handleMobileMenuItemClick,
    onModalClose: handleModalClose,
    onModalKeyDown: handleModalKeyDown,
    onPreviewItemChange: handlePreviewItemChange,
    onPreviewItemClick: handlePreviewItemClick,
    prevItemIndex: prevItemIndex || 0,
    totalImage360Count: totalImage360Count,
    totalImageCount: totalImageCount,
    totalItemCount: totalItemCount,
    totalVideoCount: totalVideoCount
  };
  return /*#__PURE__*/_react["default"].createElement(_Gallery.Gallery, (0, _extends2["default"])({}, props, injectedProps));
};
exports.WithContainer = WithContainer;